import { cx } from "../../lib/cx.js";
import { Avatar } from "../Avatar/Avatar.js";
/* empty css             */
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Identity/Identity.tsx
/**
* A person: avatar, name and a secondary line (email or role), as in the Users rows
* and the user menu. Long text is cut with an ellipsis.
*/
function Identity({ name, secondary, avatarSrc, size = "md", avatar = true, className, ...rest }) {
	return /* @__PURE__ */ jsxs("div", {
		...rest,
		className: cx("ds-identity", `ds-identity--${size}`, className),
		children: [avatar && /* @__PURE__ */ jsx(Avatar, {
			name,
			src: avatarSrc,
			size: size === "sm" ? "sm" : "md",
			decorative: true
		}), /* @__PURE__ */ jsxs("span", {
			className: "ds-identity__text",
			children: [/* @__PURE__ */ jsx("span", {
				className: "ds-identity__name",
				title: name,
				children: name
			}), secondary && /* @__PURE__ */ jsx("span", {
				className: "ds-identity__secondary",
				title: typeof secondary === "string" ? secondary : void 0,
				children: secondary
			})]
		})]
	});
}
//#endregion
export { Identity };

//# sourceMappingURL=Identity.js.map